<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 v-if="is_search" class="text-h1 mb-0">{{$t('search.searchresults')}}</h1>
      <h1 v-else class="text-h1 mb-0"> {{noteup_title}} </h1>
    </template>

    <template v-slot:leftPanel>
      <!-- Total number of results -->
      <v-card v-if="!overlay && $vuetify.breakpoint.mdAndUp" flat max-width="350" width="100%" color="lsidebg" class="pb-4 mb-3">
        <v-card-title class="pt-3 pb-1 pl-3">
          <h5 class="wdgt-title">{{$t('search.status')}}</h5>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row no-gutters class="pa-0 ma-0">
            <v-divider role="presentation"></v-divider>
          </v-row>
          <v-row v-if="bad_query" no-gutters justify="space-between">
            {{$t('error.bad_query')}}
          </v-row>
          <v-row v-else no-gutters align="baseline">
            <v-col cols="5" class="py-0 pr-0">
              <span class="statlabel darkgrey-text">{{$t('database.wdg_status_filecount')}}   </span> 
            </v-col>
            <v-col cols="7" class="px-1 pt-1 pb-0">
              <v-row no-gutters justify="space-between">
              <span class="statval darkgrey-text">{{total_matched}} {{$t('database.wdg_status_fileunit')}}</span> 
              <v-tooltip v-if="total_matched > formatted_files.length" bottom color="liiblack lighten-1" >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small color="link lighten-3" class="pb-1 pr-2">mdi-information-outline</v-icon>
                </template>
                <span> {{$t('search.max_reached', [formatted_files.length.toString()])}} </span>
              </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
          <v-divider role="presentation"></v-divider>
        </v-card-text>
      </v-card>

      <SearchResubmit v-if="is_search && $vuetify.breakpoint.smAndDown"
        :loadState="overlay"
        :isAdvanced="$route.query.searchType==='advanced'"
        :advanced_search_queries="advanced_search_queries"
        :searchWord="searchWord"
        :searchCat="classification.type"
        :recommendedKW="recommendedKW"
        :disableSemSearch="classification.type ==='ENTITY'? disableSemSearch : false"
        @toggle_fuzzy="toggle_fuzzy"
        @revise_searchword="revise_searchword"
        @revise_advanced_search="revise_advanced_search"
      />

      <!--Result Filter-->
      <v-card v-if="!overlay && !bad_query" flat :max-width="$vuetify.breakpoint.mdAndUp ? '350' : '850'" width="100%" color="lsidebg"  class="px-6 py-4 px-md-0 py-md-0 mb-0">  
        <v-card-title class="pa-0 pt-md-3 pb-md-3 pl-md-3">
          <h5 v-if="$route.query['searchType'] === 'advanced'" class="wdgt-title" >{{$t('search.changefilter')}}</h5>
          <h5 v-else-if="$vuetify.breakpoint.mdAndUp" class="wdgt-title" >{{$t('database.filter')}}</h5>
          <h6 v-else class="text-h6 font-italic mb-2">{{$t('database.filter')}}</h6>
        </v-card-title>
            
        <!--Doc Type Filter--> 
        <v-card-text class="pb-0 px-0 px-md-4">
          <h5
            v-if="$vuetify.breakpoint.smAndUp"
            class="wdgt-subtitle d-sm-inline d-md-block"
          >
            {{$t('search.doc')}}
          </h5>
          <template v-for="(item, key) in agg_dbs">
            <v-chip v-if="item.doc_count > 0" 
              :value="key" :key="item.name"
              dense label
              class="px-2 mr-1 mb-1"
              :class="selected_catlang.includes(key)? 'link lighten-5 link--text': 'transparent'"
              @click="select_catlang(key)"
            >
              {{item.name}}
              <span class="ml-1 filterdb-count" :class="`l_${item.cat}`">{{item.doc_count}}</span> 
            </v-chip>
          </template>
        </v-card-text>

        <!--Individual Db filter-->
        <v-card-text class="pb-0 px-0 px-md-4" v-show="$vuetify.breakpoint.mdAndUp">
          <v-expansion-panels flat>
            <v-expansion-panel >
              <v-expansion-panel-header active class="pl-0 py-2" color="lsidebg">
                <h6 class="wdgt-subtitle  text--secondary mb-0">{{$tc('database.indivDbs')}}</h6>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="filter-indidb" >
                
                <v-btn class="mb-2 px-2" v-if="selectedDbs.length > 0" @click="deselect_all" small elevation="0" color="link--text transparent">
                  <v-icon left small >mdi-checkbox-blank-off-outline</v-icon> {{$tc('btntxt.deselect')}}
                </v-btn>
                <v-btn class="mb-2 px-2" v-else @click="select_all" small elevation="0" color="link--text transparent">
                  <v-icon left small >mdi-checkbox-marked-outline</v-icon> {{$tc('btntxt.selectall')}}
                </v-btn>

                <template v-for="item of agg_dbs">
                  <div v-for="db in item.children" v-bind:key="db.id"  >
                    <v-checkbox 
                      v-model="selectedDbs" 
                      dense hide-details 
                      :value="db.key"
                      color="link"
                      class="filterdb my-0 py-1"
                      @click="selected_catlang=[]"
                    >
                    <template v-slot:label>
                      <span class="filterdb-name">{{db.key}}</span> 
                      <v-spacer></v-spacer> 
                      <span class="filterdb-count" :class="`l_${item.cat}`">{{db.doc_count}}</span> 
                    </template>
                    </v-checkbox>
                  </div>
                </template>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
            
        <!--Date Filter-->
        <v-card-text :class="$vuetify.breakpoint.smAndDown?'d-flex align-baseline py-0 px-0 px-md-4 pt-md-2': 'py-0 px-0 px-md-4 pt-md-2'" >
          <h5 
            v-if="$vuetify.breakpoint.smAndUp"
            class="wdgt-subtitle d-sm-inline d-md-block mr-1"
          >
            {{$t('database.daterange')}}
          </h5>
          <v-chip v-for="(item, key) in time_brackets"
            :value="key" :key="key"
            dense label
            class="mr-1 px-2"
            :class="key==selected_timebracket? 'link lighten-5 link--text': 'transparent'"
            @click="select_timebracket(key)"
          >
            {{$t(`timebracket.${key}`)}}
          </v-chip>

          <v-col class="pl-1 pr-0 py-0" v-show="$vuetify.breakpoint.mdAndUp">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="0"
              transition="scale-transition"
              offset-y
              offset-overflow
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="min_date_text"
                  :label="$i18n.t('database.startdate')"
                  v-bind="attrs"
                  v-on="on"
                  hint="DD/MM/YYYY format"
                  hide-details="auto"
                  hide-no-data dense clearable outlined
                  @blur="parse_typed_date()"
                  @keydown.enter="parse_typed_date()"
                  color="primary"
                  class="mt-5 mb-5"
                  prepend-icon=""
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="min_date"
                no-title
                min="1800-01-01"
                :max="max_date"
                @input="menu=false; min_date_text=format_date(min_date)"
                full-width
              ></v-date-picker>
            </v-menu>
                
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="0"
              transition="scale-transition"
              offset-y
              offset-overflow
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="max_date_text"
                  :label="$i18n.t('database.enddate')"
                  v-bind="attrs"
                  v-on="on"
                  hint="DD/MM/YYYY format"
                  hide-no-data dense clearable outlined
                  @blur="parse_typed_date()"
                  @keydown.enter="parse_typed_date()"
                  color="primary"
                  prepend-icon=""
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="max_date"
                no-title
                :min="min_date"
                :max="today"
                @input="menu2=false; max_date_text=format_date(max_date)"
                full-width
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-card-text>
      </v-card>
    </template>

    <template v-slot:mainPanel>

      <SearchResubmit v-if="is_search && $vuetify.breakpoint.mdAndUp"
        :loadState="overlay"
        :isAdvanced="$route.query.searchType==='advanced'"
        :advanced_search_queries="advanced_search_queries"
        :searchWord="searchWord"
        :searchCat="classification.type"
        :recommendedKW="recommendedKW"
        :disableSemSearch="classification.type ==='ENTITY'? disableSemSearch : false"
        @toggle_fuzzy="toggle_fuzzy"
        @revise_searchword="revise_searchword"
        @revise_advanced_search="revise_advanced_search"
      />
  
      <!--Sort by Buttons-->
      <v-card v-show="!bad_query" flat class="mb-3 py-4 px-6 lsidebg">
        <v-row no-gutters>
          <v-card-title class="pl-0 pr-8 py-0 pb-2 pb-sm-0" >
            <h6 class="text-h6 font-italic"> {{$t('database.sortby')}} </h6>
          </v-card-title>

          <v-btn-toggle mandatory v-model="toggle_sort" color="link" class="flex-wrap lsidebg"  >
            <v-btn small tile active-class="link lighten-5" class="px-4" value="relevance" >
              {{$t('database.relevance')}}
            </v-btn>

            <v-btn small tile active-class="link lighten-5" class="px-4 " value="dateDesc">
              {{$t('database.date')}}
              <v-icon small  class="ml-3">mdi-arrow-down</v-icon>
            </v-btn>

            <v-btn small tile active-class="link lighten-5" class="px-4" value="dateAsc">
              {{$t('database.date')}}
              <v-icon small  class="ml-3">mdi-arrow-up</v-icon>
            </v-btn>
          </v-btn-toggle>

        </v-row>
      </v-card>

      <!--Error / Help-->
      <v-alert
        dense text
        type="error"
        class="mb-5"
        icon="mdi-alert-outline"
        v-if="!overlay && bad_query"
      >
        <span>{{$t("error.bad_query")}}</span>
      </v-alert>

      <v-alert
        dense text
        type="warning"
        class="mb-5"
        icon="mdi-alert-circle-outline"
        v-if="!overlay && !bad_query && files.length == 0"
      >
        <span>{{$t("error.noresult_warn")}}</span>
      </v-alert>

      <!--Legis suggestion-->
      <v-alert
        v-if="classification.type==='LEGIS' && $route.query['searchType'] !== 'advanced' && legisSuggestion.capNum !=='' "
        border="left" colored-border color="l_legis"
        dense 
        icon="mdi-text-box-search-outline"
        class="lsidebg legis-suggestion"
      >
        {{$t('search.legis_rec')}}
        <router-link :to="legisSuggestion.path">{{legisSuggestion.capNum}} <b>{{legisSuggestion.title}}</b></router-link>?
        <router-link to="/news#search_legis" >
          <span class="beta-tag link--text px-2 ml-1" >{{$t('btntxt.newfeature')}}</span>
        </router-link>
      </v-alert>

      <!--Results Data Table-->
      <v-card  class="pa-0">
        <v-data-table
          :headers="computedHeaders"
          :items="filtered_files"
          :page.sync="page"
          calculate-widths hide-default-footer
          :items-per-page="options.itemsPerPage || resultsperpage"
          :options.sync="options"
          @page-count="page_count = $event"
          dense
          class="resultdt"
          :no-data-text="$i18n.t('error.noresult_warn')"
          :no-results-text="$i18n.t('error.noresult_warn')"
        >
          <template v-slot:item="{ item }">
            <!--results at desktop-->
            <tr v-if="$vuetify.breakpoint.smAndUp" @click="(event)=>goFile(item,event)" class="resultrow white" >
              <td class="pl-3 pr-1 py-1 hidden-sm-and-down" valign="top"> <!--docType-->
                <router-link :to="{path: item.path, query: {hl: $route.query.q}}" class="routing">
                  <span :class="`resulttype l_${item.type}`">{{$t(`labels.${item.type}`)}}</span>
                </router-link>
              </td>
              <td class="pl-0 pr-1" :class="$vuetify.breakpoint.smOnly?'py-0 ':'py-1 pl-3'"> <!--database-->
                <router-link :to="{path: item.path, query: {hl: $route.query.q}}" class="routing">
                  <v-row v-if="$vuetify.breakpoint.smOnly" class="d-flex fill-height" no-gutters>
                    <!--add stripe here to indicate colour-->
                    <v-col cols="12" class="py-1 pl-3 pr-1" :style="`border-left: 4px solid var(--v-l_${item.type}-base);`" ><p class="resultcontent ">{{item.database}}</p></v-col>
                  </v-row>
                  <p v-else class="resultcontent">{{item.database}}</p>
                </router-link>
              </td>
              <td class="pr-3 py-1"> <!--document title-->
                <router-link :to="{path: item.path, query: {hl: $route.query.q}}" class="routing">
                  <p class="resultcontent resulttitle" v-html="item.title"></p>
                  <p v-html="item.subtitle" class="resultcontent darkgrey--text"></p>
                </router-link>
              </td>
              <td class="pr-1 py-1"> <!--date-->
                <router-link :to="{path: item.path, query: {hl: $route.query.q}}" class="routing">
                  <p class="resultcontent">{{item.datestr}}</p>
                </router-link>
              </td>
            </tr>

            <!--results at mobile-->
            <tr v-else @click="(event)=>goFile(item,event)" class="resultrow white" >
              <td class="pl-4 pr-2 pt-2 pb-0 v-data-table__mobile-row"> <!--docType-->
                <router-link class="routing" :to="{path: item.path, query: {hl: $route.query.q} }">
                  <span :class="`resulttype l_${item.type}`">{{$t(`labels.${item.type}`)}}</span>
                  <span class="pl-2">{{item.database}}</span> <br>
                  <span class=" resulttitle" v-html="item.title"></span> <br>
                  <span v-html="item.subtitle" class="darkgrey--text"></span> <br>
                  <span>{{item.datestr}}</span>
                  <p></p>
                </router-link>
              </td>
            </tr>

          </template>

          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer 
            show-current-page  show-first-last-page
            :pagination="pagination" 
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[20, 50, 100]"
            :items-per-page-text="$t('tbhead.itemperpage')"
            />
          </template>
        </v-data-table>
            
        <!--Results Pagination AT END OF results-->
        <v-row no-gutters>           
          <v-col class="py-0">
            <v-pagination 
              color="link"
              class="lsidebg py-3"
              v-model="page" 
              :length="page_count" 
              :total-visible="$vuetify.breakpoint.smAndDown? 7:9"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card>

      <!--Go to Adv Search Bar-->
      <v-card flat class="mt-8 py-4 px-6 rsidebg" v-if="is_search && $vuetify.breakpoint.mdAndDown ">
        <v-row no-gutters>
          {{$t('search.toadv')}}
          <v-spacer ></v-spacer>
          <v-btn 
            small dense text color="navlink"
            @click="revise_advanced_search"
            class="pr-0 pl-1"
            :class="$vuetify.breakpoint.xsOnly? 'mt-3':''"
          >
            {{$t('btntxt.goto')}}{{$t('search.advs.advanced')}}
            <v-icon> mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-card>

      <!--loading overlay-->
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
      </v-overlay>
    </template>
        
    <template v-slot:rightPanel v-if="$vuetify.breakpoint.lgAndUp">
      <!--Go to Adv Search for larger screens-->
      <v-card v-if="is_search" flat class="rsidecard mb-4 mr-3 pb-3" max-width="350" min-width="250" width="100%">
        <v-card-title class="px-5 pb-1">
          <h5 class="wdgt-title" >{{$t('search.advs.help')}}</h5>
        </v-card-title>
        <v-card-text class="px-5">
          {{$t('search.toadv')}}
        </v-card-text>
        <v-card-actions class="px-5">
          <v-btn 
            color="navlink" 
            outlined block
            @click="revise_advanced_search" 
          >
            {{$t('btntxt.goto')}}{{$t('search.advs.advanced')}}
          </v-btn>
        </v-card-actions>

        <v-card-actions class="px-5">
          <v-btn 
          color="navlink" 
          outlined block
          :to="{name:'operators'}"
          >
            {{$t('btntxt.howto')}}{{$t('operators.t_operators')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </ThreeColumn>
</template>


<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import SearchResubmit from '@/components/SearchResubmit'
  import StatusWidget from '../components/StatusWidget'
  import dbs_simplified from '../data/dbs_simplified.json'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  export default {
    name: 'SearchResults',
    components:{
      ThreeColumn,
      StatusWidget,
      SearchResubmit
    },
    data(){
      return {
        overlay:false,
        bad_query: false,
        searchWord: '',
        text: '',
        title: '',
        captitle: '',
        parties: '',
        coram: '',
        min_date: null,
        max_date: null,
        min_date_text: '',
        max_date_text: '',
        time_brackets: datehelper.default_time_brackets,
        selected_timebracket: '',  // recent7 / recent30 / recent1y / recent5y
        // dates: [],
        today: datehelper.today_str(),
        menu: false,
        menu2: false,
        representation: '',
        phrase: '',
        noteup: '',  // keep
        charge: '',
        anyword: '',
        citation: '',
        action: '',
        prefix: '',
        page: 1,
        page_count: 0,
        files: [],
        classification: '',
        rel_keyword: [],
        selectedDbs: [],
        resultsperpage: this.$route.name === 'search-results' ? 20 : 100,
        // sort:'relevance',
        //sorts: ['relevance', 'date','title'],  //not in use?
        selectedField: 'none',
        fields: [
          {value: 'citation', text: 'Citation'},
          {value: 'action', text: 'Action'},
          {value: 'title', text: 'Title'},
          {value: 'captitle', text: 'Legislation Name'},
          {value: 'parties', text: 'Parties'},
          {value: 'coram', text: 'Coram'},
          {value: 'charge', text: 'Charge'},
          {value: 'representation', text: 'Representation'},
          {value :'none', text: 'None'},
        ],
        agg_dbs: null,
        selected_catlang: [],
        formatted_files: [],
        filter_flag: true,
        date_range_min: null,
        date_range_max: null,
        options: {},
        toggle_sort: 'relevance', //sort by button
        total_matched: null , //  May be more than the total returned results if it is returned by ES
        disableSemSearch: null, //false
        legisSuggestion: {
          title: '',
          capNum: '',
          path: '',
        },
      }
    },
    methods:{
      parse_date: datehelper.parse_date,
      format_date: datehelper.format_date,
      date_to_text: datehelper.date_to_text,
      goFile(item, event){
        var selectedText = getSelection().toString()
        // since there are children in the router-link tag in the result row, we need check the path of the event
        if (selectedText.length == 0 && !event.path.map(node => node.tagName).includes("A")){
          let routeData = this.$router.resolve({path: item.path, query: {hl: this.$route.query.q}});
          if (event.ctrlKey){
            // Ctrl + click: open in new tab
            var w = window.open(routeData.href, '_blank')
            if (event.shiftKey){
              // Ctrl + Shift + click: open in new tab and focus
              w.focus()
            }
          } else if (event.shiftKey){
            // Shift + click: open in new tab
            window.open(routeData.href)
          } else {
            this.$router.push({path: item.path, query: {hl: this.$route.query.q}})
          }
        }
      },
      revise_searchword(sw, ss){
        // simple search
        if(sw !== '' && sw !== this.searchWord){  // do not search if the search box is empty or unchanged
          this.searchWord = sw
          this.disableSemSearch = ss
          this.options.page = 1
          var disable = this.disableSemSearch? 1 : 0
          this.$router.push({name: this.$route.name, query: {q: this.searchWord, d: disable}})
        }
      },
      toggle_fuzzy(ss){
        this.disableSemSearch = ss
        this.options.page = 1
        var disable = ss ? 1 : 0
        this.$router.push({name: this.$route.name, query: {q: this.searchWord, d: disable}})
      },
      revise_advanced_search(){
        this.options.page = 1
        var q = {...this.$route.query}
        delete q.searchType
        this.$router.push({name: 'advanced-search', query: q})
      },
      async trigger_search_api(){
        this.overlay = true
        const _query = this.$route.query
        var res
        try {
          if(this.is_search){
            if(this.$route.query['searchType'] === 'advanced'){
              res = await api.advanced_search(_query)
            } else {
              res = await api.simple_search(_query.q, _query.d)
              this.classification = res['classification']
              this.rel_keyword = res['recommendation']
            }
            this.files = res['results']
            this.total_matched = res['count']
            
            if(this.classification.type === "LEGIS"){
              this.get_legisName()
            }
          } else {
            if (this.$route.name === 'legis-noteup'){
              res = await api.get_legisnoteup(_query.lang, _query.cap, _query.num)
            } else if (this.$route.name === 'case-noteup'){
              res = await api.get_casenoteup(_query.abbr, _query.year, _query.num)
            }
            this.files = res
            this.total_matched = res.length
          }
        } catch(err) {
          console.error(err)
        } finally {
          this.overlay = false
        }
      },
      async get_non_eng_legis_title(lang, cap, abbr){
        var res
        try{
           res = await api.get_cap(lang, cap, abbr)
           this.legisSuggestion.title = res['title']
        } catch(err) {
          console.error(err)
        }

      },
      trigger_search(){
        return this.trigger_search_api().then(() => {
          this.bad_query = false
        }).catch(error => {
          this.files = []
          this.bad_query = true
        }).finally(() => {
          this.format_files()
          this.initialize_filters()
          this.overlay = false
        })
      },
      format_files(){
        this.formatted_files = this.files.map(file => this.format_row(file))
      },
      reset_agg_dbs(){
        this.agg_dbs = {
          cases_en: {name: 'Case(EN)', cat: 'case', children: [], doc_count: 0},
          cases_tc: {name: '判案書(繁)', cat: 'case', children: [], doc_count: 0},
          cases_sc: {name: '判案书(简)', cat: 'case', children: [], doc_count: 0},
          legis_en: {name: 'Legis(EN)', cat: 'legis', children: [], doc_count: 0},
          legis_tc: {name: '法例(繁)', cat: 'legis', children: [], doc_count: 0},
          legis_sc: {name: '法例(简)', cat: 'legis', children: [], doc_count: 0},
          other_en: {name: 'Other(EN)', cat: 'other', children: [], doc_count: 0},
          other_tc: {name: '其他(繁)', cat: 'other', children: [], doc_count: 0},
          other_sc: {name: '其他(简)', cat: 'other', children: [], doc_count: 0},
        }
      },
      initialize_filters(){
        this.reset_agg_dbs()
        this.selected_timebracket = ''
        var counts = {}
        for (var file of this.formatted_files){
          const db_name = file.database
          counts[db_name] = counts[db_name] ? counts[db_name] + 1 : 1;
        }
        const regexCatLang = /\/(\w+)\/(\w+)\/.*/
        for (var db_name in counts){
          const db = dbs_simplified.find(db => db.name === db_name)
          const match = db.path.match(regexCatLang)
          const cat_lang = `${match[2]}_${match[1]}`  // eg. cases_en
          this.agg_dbs[cat_lang].children.push({id: db.id, key: db.name, doc_count: counts[db_name]})
          this.agg_dbs[cat_lang].doc_count += counts[db_name]
        }
        // only include the selected dbs in advanced search page
        // if all dbs are selected or no db filter indicated, we leave the selectedDb blank
        if ('dbs' in this.$route.query){
          var db_ids = this.$route.query['dbs'].split(',')
          this.selectedDbs = dbs_simplified.filter(
            db => db_ids.includes(db.id.toString()) && counts[db.name] > 0
          ).map(db => db.name)
        } else {
          this.select_all()
        }
        // date range
        var dates = this.formatted_files.map(file => file.date)
        if ('min_date' in this.$route.query){
          this.min_date = this.parse_date(this.$route.query['min_date'])
        } else if(this.formatted_files.length > 0){
          this.min_date = this.date_to_text(new Date(Math.min.apply(null, dates)))
        } else {
          this.min_date = this.date_to_text(new Date('1970-01-01T00:00:00'))
        }
        if ('max_date' in this.$route.query){
          this.max_date = this.parse_date(this.$route.query['max_date'])
        } else if (this.formatted_files.length > 0){
          this.max_date = this.date_to_text(new Date(Math.max.apply(null, dates)))
        } else {
          this.max_date = this.date_to_text(new Date())
        }
      },
      deselect_all(){
        this.selected_catlang = []
        this.selectedDbs = []
      },
      select_all(){
        this.deselect_all()
        Object.values(this.agg_dbs).forEach(cl => {
          const db_names = cl.children.map(db => db.key)
          this.selectedDbs = this.selectedDbs.concat(db_names)
        })
      },
      select_catlang(key){
        if (this.selected_catlang.includes(key)){
          this.selected_catlang = this.selected_catlang.filter(k => k !== key)
        } else {
          this.selected_catlang.push(key)
        }
        if (this.selected_catlang.length == 0){
          this.select_all()
        } else {
          this.selectedDbs = []
          for (key of this.selected_catlang){
            const db_names = this.agg_dbs[key].children.map(db => db.key)
            this.selectedDbs = this.selectedDbs.concat(db_names)
          }
        }
      },
      parse_typed_date(){
        this.selected_timebracket = ''
        this.min_date = this.parse_date(this.min_date_text)
        this.min_date_text = this.format_date(this.min_date)
        this.max_date = this.parse_date(this.max_date_text)
        this.max_date_text = this.format_date(this.max_date)
      },
      select_timebracket(key){
        if (this.selected_timebracket == key){
          this.selected_timebracket = ''
          this.min_date = null
          this.max_date = null
        } else {
          this.selected_timebracket = key
          const bracket = this.time_brackets[key]
          this.min_date = bracket[0]
          this.max_date = bracket[1]
        }
      },
      format_row(row){
        // doctype
        var pageType = this.$router.match(row.path).name
        var docType = 'other'
        if(pageType == 'case'){
          docType = 'case'
        } else if (pageType == 'section' || pageType == 'sectiontoc'){
          docType = 'legis'
        }

        // date, datestr
        var datestr = ''
        var date = null
        if (row.pub_date){
          date = new Date(row.pub_date.slice(0, 25)).getTime()
        } else if (row.date) {
          date = new Date(row.date.slice(0, 25)).getTime()
        }
        if(docType == 'case' || docType == 'legis'){
          datestr = datehelper.display_date(row.pub_date || row.date || null)
        }

        // title
        var title = ''
        if (this.is_search){
          title = row.title
        } else if (docType == 'case'){
          title = row.cases.map(c => c.title).join('<br/>')
        } else {
          title = row.title
        }

        // subtitle
        var subtitle = ''
        if (docType == 'legis'){
          if (row['subtitle']){
            subtitle = row['subtitle']
          } else {
            var params = this.$router.match(row.path).params
            var cap = (params.abbr == 'instrument') ? 'Instrument' : 'Cap'
            var prov_num = 'num' in params ? this.long_prov(params.num, params.lang) : ''
            subtitle = `${cap} ${params.cap} ${prov_num}`
          }
        } else if (this.is_search && docType == 'case'){
          //modified by sw to separate citations from title
          const arr = [ row.neutral, row.act, row.parallel]
          subtitle = arr.filter(function(item){return item}).join('; ');
        } else if (docType == 'case'){
          subtitle = [row.neutral].concat(row.parallel).concat(
            row.cases.map(c => c.act)
          ).join('; ')
        }

        return {
          'type': docType, 
          'database': row.db,
          'title': title,
          'subtitle': subtitle,
          'datestr': datestr,
          'date': date,
          'path': row.path
        }
      },
      handle_toggle_sort(){
        if(this.options.sortBy.length==0){
          this.toggle_sort='relevance'
        } else if(this.options.sortBy[0]=='date'){
          if(this.options.sortDesc[0]){
            this.toggle_sort = 'dateDesc'
          } else {this.toggle_sort = 'dateAsc'}
        }
      },
      long_prov(num, lang){
        if (num.match(/((s|sch|ann|app)\d+)|(longTitle|preamble)/)){ 
          // section / schedule / annex / appendix / long Title / preamble
          return ''
        } else {
          var prov_arr = num.split('_')
          const ProvisionTypes = {
            en: {
              "P": "Part {0}",
              "SD": "Subdivision {0}",
              "D": "Division {0}"
            },
            tc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            },
            sc: {
              "P": "第{0}部",
              "SD": "第{0}次分部",
              "D": "第{0}分部",
            }
          }
          const regex = /(P|SD|D|)(\d+\w*)/
          var conv_prov = prov_arr.map((segment) => {
            var found = segment.match(regex)
            if (found){
              return ProvisionTypes[lang][found[1]].replace('{0}', found[2]) || ''
            } else {
              return segment
            }
          })
          return conv_prov.join(' ')
        }
      },
      get_legisName(){
        this.legisSuggestion.title = ''
        this.legisSuggestion.capNum = ''
        this.legisSuggestion.path =''
        var c = this.classification
        
        if (c.cap !== null && c.cap !== ''){
          var lang = this.$i18n.locale
          var capnum = ( c.prefix == null? "" : c.prefix ) + c.cap + ( c.suffix == null? "" : c.suffix )
          var ltype = c.prefix === 'A'? 'instrument' : capnum.match(/\d+[A-Z]/)? 'reg' : 'ord' 

          if( lang=="en"){
            this.legisSuggestion.title = c.title
          }else{
            //console.log(capnum)
            this.get_non_eng_legis_title(lang, capnum, ltype)
          }

          this.legisSuggestion.capNum =  'Cap ' + capnum
          this.legisSuggestion.path = "/" + lang + "/legis/" + ltype + "/" + capnum
        }
      },
    },
    computed:{
      is_search(){
        return this.$route.name === 'search-results'
      },
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.is_search ? this.$t('btntxt.search') : "Noteup", disabled: true}
        ]
      },
      noteup_title(){
        var query = this.$route.query
        if (this.$route.name === 'legis-noteup'){
          var cap = query.cap.startsWith('A') ? 'Instrument' : 'Cap'
          var prov_num = 'num' in query ? this.long_prov(query.num, this.$i18n.locale) : ''
          return `Noteup — ${cap} ${query.cap} ${prov_num}`
        } else if (this.$route.name === 'case-noteup'){
          return `Noteup — [${query.year}] ${query.abbr.toUpperCase()} ${query.num}`
        } else {
          return ''
        }
      },
      computedHeaders () {
        return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide])  
      },
      headers(){ //table header
        return [
          { text: this.$i18n.t('tbhead.srch_type'), value: 'type', width: '10%', sortable: false, hide: 'smAndDown'},
          { text: this.$i18n.t('tbhead.case_db'), value: 'database', width: '20%', sortable: false},
          { text: this.$i18n.t('tbhead.srch_doctitle'), value: 'title', sortable: false},
          { text: this.$i18n.t('database.date'), value: 'date', width: '14%', sortable: true},
        ]
      },
      filtered_files(){
        var filtered = []
        for(var file of this.formatted_files){
          var date_lb_okay = !file.date || !this.date_range_min || file.date >= this.date_range_min
          var date_ub_okay = !file.date || !this.date_range_max || file.date <= this.date_range_max
          if (date_lb_okay && date_ub_okay){
            if (this.selectedDbs.includes(file.database)){
              filtered.push(file)
            }
          }
        }
        return filtered
      },
      advanced_search_queries(){
        const FIELDS = {
          citation: this.$t('search.advs.citation'),
          title: this.$t('database.casename'),
          captitle: this.$t('search.advs.legisname'),
          parties: this.$t('search.advs.parties'),
          coram: this.$t('search.advs.coram'),
          representation: this.$t('search.advs.representation'),
          charge: this.$t('search.advs.charge'),
          text: this.$t('search.advs.allwords'),
          anyword: this.$t('search.advs.anywords'),
          phrase: this.$t('search.advs.phrase'),
          min_date: this.$t('database.startdate'),
          max_date: this.$t('database.enddate')
        }
        var formatted = {}
        for(var q in this.$route.query){
          if(q in FIELDS){
            formatted[FIELDS[q]] = this.$route.query[q]
          }
        }
        return formatted
      },
      sort_str(){  // for easy watching
        if(this.options.sortBy && this.options.sortBy.length > 0){
          var sortBy = this.options.sortBy[0]
          var direction = ''
          if (this.options.sortDesc.length > 0){
            if (this.options.sortDesc[0]){
              direction = 'Desc'
            } else {direction = 'Asc'}
          }
          return sortBy + direction
        } else { return '' }
      },
      recommendedKW(){
        if(this.rel_keyword.message==='Success'){
          var kwlist = this.rel_keyword.data
          return this.$vuetify.breakpoint.xs? kwlist.slice(0, Math.min(8, kwlist.length)) : kwlist
        } else {
          return []
        }
      },
    },
    watch:{
      '$route.fullPath': function () {
        this.overlay= true
        this.trigger_search()
        this.searchWord = this.$route.query.q
      },
      'options.page': function(){
        window.scrollTo(0,0)
      },
      sort_str(){
        this.handle_toggle_sort()
      },
      toggle_sort(){
        if(this.toggle_sort == 'relevance'){
          this.options.sortBy = []
          this.options.sortDesc = []
        }else if(this.toggle_sort == 'citFreq'){
          // not implemented yet
          this.options.sortBy = ['citFreq']
          this.options.sortDesc = [true]
        }else if(this.toggle_sort == 'dateDesc'){
          this.options.sortBy = ['date']
          this.options.sortDesc = [true]
        }else if(this.toggle_sort == 'dateAsc'){
          this.options.sortBy = ['date']
          this.options.sortDesc = [false]
        }
        this.options.page = 1
      },
      min_date (val) {
        this.min_date_text = this.format_date(this.min_date)
        if (this.min_date){
          this.date_range_min = new Date(this.min_date + 'T00:00:00')
        } else {
          this.date_range_min = null
        }
      },
      max_date (val) {
        this.max_date_text = this.format_date(this.max_date)
        if (this.max_date){
          this.date_range_max = new Date(this.max_date + 'T23:59:59')
        } else {
          this.date_range_max = null
        }
      },
    },
    mounted(){
      this.overlay = true
      this.trigger_search()
      this.searchWord = this.$route.query.q
      this.disableSemSearch = this.$route.query.d? true : false
      //window.document.title = this.is_search ? "Search Results | HKLII" : "Noteup | HKLII"
    },
    metaInfo(){
      return{
        title: this.is_search ? this.$i18n.t('search.searchresults') : "Noteup",
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/_typography.scss';

  /*legis suggestion*/
  .dbfilterbox{
    border-left: 5px solid var(--v-l_legis-base) !important;
  }

 .legis-suggestion {
    font-size: 0.95em;
    a {
      @include link-underlined;
    }
  }
 
 .legis-suggestion ::v-deep .v-icon::before{
    color: #f3c580;
  }

  /*Narrow by box*/
  .filterdb{
    align-content:flex-start;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  .v-input--selection-controls{ 
    padding-top: 10px; 
  }

  .filterdb-name{
    font-size: 9.8pt !important;
    font-weight: 600;
  }
  .filterdb-count{
    font-size: 9.8pt !important;
    background: var(--v-link-lighten5);
    border-radius: 10px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .filter-indidb ::v-deep .v-expansion-panel-content__wrap{ 
    padding: 0px 0px; /*remove padding */
  }
  .theme--light.v-expansion-panels .v-expansion-panel{ 
    background-color: rgba(0, 0, 0, 0); 
  }

  .resultheader{
    font-size: 10pt !important;
    font-weight: 600;
  }
  /* Sort*/

  /* result table */
  .resultdt ::v-deep tr {
    /*background: var(--v-lsidebg-base);*/
    cursor: pointer;
  }

  tr.resultrow>td {
    vertical-align: top;
  }

  .resultcontent {
    font-size: 10.5pt !important;
    line-height: 13.5pt !important;
    margin-bottom: 3px;
    margin-top: 4px;
  }

  .resulttitle {
    font-weight: 600;
  }

  .resulttype {
    font-size: 9pt !important;
    line-height: 11pt !important;
    background: var(--v-darkgrey-lighten4);
    border-radius: 10px;
    padding: 2px 5px 2px;
    display: inline-block;
  }

  textarea{
    font-size: smaller;
  }

  /*result count stat widget*/
  .statlabel{
      font-size: 9.3pt;
      line-height: 12.5pt;
      font-stretch: semi-condensed;
      word-break: normal
  }
  .statval{
      font-size: 9.3pt;
      line-height: 12.5pt;
      font-weight: 700;
      word-break: normal
  }

  /*filter panel*/
  .v-expansion-panel-header{
    padding-right: 0px !important;
  }
  .v-expansion-panel-header--active{
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }

 /*beta test */
  .beta-card{
    border: 1px solid var(--v-link-base) !important;
  }
</style>

